<template>
    <div name="maps" class="maps">
        <!-- 컨시어지 로고 -->
        <div class="header" @click="markerReset">
            <img class="logo" src="../../../assets/concierge_logo.png" />
        </div>
        <div v-if="isMapSearchButton" class="map-search-button" @click="searchMap">현 지도에서 검색</div>
        
        <div id="map" style="width: 100%; height: calc(100vh)"></div>
        <!-- 목록 보기 버튼 -->
        <button class="list-view-button" @click="changeView">
            <img style="margin-right: 8px;" src="../../../assets/ham.png" />
            <span>목록보기</span>
        </button>
        <div class="custom-button-1">
            <img style="width: 100%;" src="../../../assets/channel_talk.png" />
        </div>
        <button class="navigator-button" @click="getLocation">
            <img style="width: 28px;" src="../../../assets/location.png"/>
        </button>
        <!-- 바텀 팝업 -->
        <div class="bottom-popup" :class="{ show: isPopupVisible } ">
            <pharmacy-card 
                v-if="selectedMarker"
                :info="selectedMarker"
                :isList="false"
                @share="share"
                @viewDetail="viewDetail"
            />
        </div>

         <!-- 검색 -->
        <map-search-bottom 
            @onSearch="onSearch"
            :preKeyword="preKeyword"
            @changeMapView="changeView"
        />

        <!-- 위치 공유 버튼 -->

    </div>
</template>

<script>
import {mapState} from 'vuex';
import Constant from '@/constant';
import PharmacyCard from '@/components/molecules/maps/PharmacyCard';
import MarkerClustering from "@/utilities/MarkerClustering"; // 경로 확인
import MapSearchBottom from '@/components/molecules/maps/MapSearchBottom.vue';

export default {
    name: 'maps',
    props: ['baseLatitude', 'baseLongitude', 'preKeyword', 'selectedPharmacy', 'savedZoomLevel'],
    components: {
        PharmacyCard,
        MapSearchBottom
    },
    computed: mapState(['pharmacies']),
    data: function()
    {
        return {
            map: null,
            selectedMarker: null,
            isPopupVisible: false, // 팝업 상태
            longitude: this.baseLongitude,
            latitude: this.baseLatitude,
            lastSelectedMarker: null,
            markers: [],
            isMapSearchButton: false,
            keyword: '',
            zoomLevel: this.savedZoomLevel
        }
    },
    mounted: function()
    {
        this.initMap()
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
            "customLauncherSelector": ".custom-button-1",
            "hideChannelButtonOnBoot": true
        });
        this.keyword = this.preKeyword;
    },
    methods: {
        viewDetail: function(info)
        {
            this.$emit('viewDetail', info)
        },
        searchMap: function()
        {
            this.isMapSearchButton = false;
            // map의 중심 좌표에서 그대로 검색 
            this.zoomLevel = this.map.getZoom();
            const center = this.map.getCenter();
            this.$emit('onSearchMap', this.keyword, center.lat(), center.lng())
        },
        getLocation: function()
        {
            if (navigator.geolocation) {
                const options = {
                    enableHighAccuracy: true, // (선택) 좀 더 정확한 위치 요청
                    timeout: 5000,            // 5초 이상 걸리면 실패로 간주
                    maximumAge: 0             // 캐시된 위치 무시
                };

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        this.longitude = lng;
                        this.latitude = lat;
                        this.$store.commit(Constant.SET_PHARMACY_USER_LOCATION, {
                            latitude: lat,
                            longitude: lng
                        });
                        console.log("현재 위치:", lat, lng);
                        this.map.setCenter(new naver.maps.LatLng(this.latitude, this.longitude));
                        this.map.setZoom(this.zoomLevel); // 원하는 줌 레벨
                        this.searchMap(); // 위치 기반 검색 실행
                    },
                    (error) => {
                        // error.code 값에 따라 메시지 다르게 처리 가능
                        let msg = "위치 정보를 가져올 수 없습니다.";
                        if (error.code === error.TIMEOUT) {
                            msg = "요청이 너무 오래 걸려 위치 정보를 가져오지 못했습니다.";
                        } else if (error.code === error.PERMISSION_DENIED) {
                            msg = "위치 접근이 차단되었습니다.";
                        } else if (error.code === error.POSITION_UNAVAILABLE) {
                            msg = "위치 정보를 사용할 수 없습니다.";
                        }

                        alert(msg);
                        console.error(msg, error);
                    },
                    options
                );
            } else {
                alert("위치 정보를 가져올 수 없습니다.");
                console.error("이 브라우저에서는 위치 정보를 사용할 수 없습니다.");
            }
        },
        changeView: function()
        {
            this.zoomLevel = this.map.getZoom();
            this.$emit('changeView', this.keyword, this.zoomLevel)
        },
        onSearch: function(query)
        {
            this.keyword = query;
            const center = this.map.getCenter();
            this.$emit('onSearch', query, center.lat(), center.lng())
        },
        initMap: async function()
        {
            this.map = new naver.maps.Map("map", {
               zoom: this.zoomLevel,  
               center: new naver.maps.LatLng(this.baseLatitude, this.baseLongitude),
               zoomControl: true,
               zoomControlOptions: {
               position: naver.maps.Position.TOP_LEFT,
               style: naver.maps.ZoomControlStyle.SMALL
               }
            });
            this.markers = []
            var data = this.pharmacies;


            for (let i = 0, ii = data.length; i < ii; i++) {
                const spot = data[i];
                
                const latlng = new naver.maps.LatLng(spot.latitude, spot.longitude);
        
                const marker = new naver.maps.Marker({
                    position: latlng,
                    map: this.map,
                    icon: {
                        url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                        size: new naver.maps.Size(29, 29), // 이미지 크기
                        scaledSize: new naver.maps.Size(29, 29),
                        origin: new naver.maps.Point(0, 0), // 이미지 원점
                        anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                    }
                });

                if(this.selectedPharmacy !== null)
                {
                    if(this.selectedPharmacy.index === data[i].index)
                    {
                        this.selectedMarker = data[i];
                        marker.setIcon({
                            content: `        
                            <div style="position: relative; display: inline-block;">
                            <!-- 말풍선 본체 -->
                            <div style="
                                background: #1a1a1a;
                                height: 39px;
                                border-radius: 16px;
                                color: var(--Gray-primary-color2, #FFF);
                                font-family: Pretendard;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px; /* 142.857% */
                                display: inline-block;
                                box-sizing: border-box;
                                width: 110.5px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                z-index: 99999; 
                            ">
                                💉 ${this.selectedMarker.name.length > 5 ? this.selectedMarker.name.substring(0, 5) + "..." : this.selectedMarker.name}
                            </div>

                            <!-- 꼬리 삼각형 -->
                            <div style="
                                position: absolute;
                                bottom: -8px;
                                left: 15%;
                                transform: translateX(-15%);
                                width: 0;
                                height: 0;
                                border-left: 8px solid transparent;
                                border-right: 8px solid transparent;
                                border-top: 8px solid #1a1a1a;
                                 z-index: 99999; 
                            "></div>
                            </div>`,
                            size: new naver.maps.Size(22, 35),
                            anchor: new naver.maps.Point(11, 35)
                        });

                        this.lastSelectedMarker = marker;
                        this.map.setCenter(marker.getPosition());
                        this.map.setZoom(18); // 원하는 줌 레벨
                        this.isPopupVisible = true;
                    }
                }
                else
                {
                    this.isPopupVisible = false;
                }
                  
                // 마커 클릭 이벤트 (바텀 팝업 표시)
                naver.maps.Event.addListener(marker, "click", () => {
                    this.isPopupVisible = true;
    
                    // 이전에 선택된 마커 돌리기
                    if(this.lastSelectedMarker !== null)
                    {
                        this.lastSelectedMarker.setIcon({
                            url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                            size: new naver.maps.Size(29, 29), // 이미지 크기
                            scaledSize: new naver.maps.Size(29, 29),
                            origin: new naver.maps.Point(0, 0), // 이미지 원점
                            anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                        })
                    }

                    this.lastSelectedMarker = marker;
                    this.map.setCenter(marker.getPosition());
                    this.map.setZoom(18); // 원하는 줌 레벨
                    this.selectedMarker = data[i];

                    marker.setIcon({
                        content: `        
                        <div style="position: relative; display: inline-block;">
                        <!-- 말풍선 본체 -->
                        <div style="
                            background: #1a1a1a;
                            height: 39px;
                            border-radius: 16px;
                            color: var(--Gray-primary-color2, #FFF);
                            font-family: Pretendard;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 20px; /* 142.857% */
                            display: inline-block;
                            box-sizing: border-box;
                            width: 110.5px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                           z-index: 99999; 
                        ">
                            💉 ${this.selectedMarker.name.length > 5 ? this.selectedMarker.name.substring(0, 5) + "..." : this.selectedMarker.name}
                        </div>

                        <!-- 꼬리 삼각형 -->
                        <div style="
                            position: absolute;
                            bottom: -8px;
                            left: 15%;
                            transform: translateX(-15%);
                            width: 0;
                            height: 0;
                            border-left: 8px solid transparent;
                            border-right: 8px solid transparent;
                            border-top: 8px solid #1a1a1a;
                         z-index: 99999; 
                        "></div>
                        </div>`,
                        size: new naver.maps.Size(22, 35),
                        anchor: new naver.maps.Point(11, 35)
                    });
                    // selected marker
                });      
                this.markers.push(marker);
            }


            // click, drag 이벤트 추가 
            naver.maps.Event.addListener(this.map, "click", (event) => {
                this.isPopupVisible = false;
                if(this.lastSelectedMarker !== null)
                {
                    this.lastSelectedMarker.setIcon({
                        url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                        size: new naver.maps.Size(29, 29), // 이미지 크기
                        scaledSize: new naver.maps.Size(29, 29),
                        origin: new naver.maps.Point(0, 0), // 이미지 원점
                        anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                    })
                }
                this.selectedMarker = null;
                this.lastSelectedMarker = null;

            });

            naver.maps.Event.addListener(this.map, "dragstart", () => {
                this.isMapSearchButton = true;
                this.isPopupVisible = false;
                if(this.lastSelectedMarker !== null)
                {
                    this.lastSelectedMarker.setIcon({
                        url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                        size: new naver.maps.Size(29, 29), // 이미지 크기
                        scaledSize: new naver.maps.Size(29, 29),
                        origin: new naver.maps.Point(0, 0), // 이미지 원점
                        anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                    })
                }
                this.selectedMarker = null;
                this.lastSelectedMarker = null;
            });

            var htmlMarker1 = {
              content: '<div style="cursor:pointer;width:44px;height:44px;line-height:42px;font-size:20px;color:white;text-align:center;font-weight:600;background:rgba(24, 79, 161, 0.83);border-radius: 50%;"></div>',
              size: N.Size(40, 40),
              anchor: N.Point(20, 20)
            }

            var markerClustering = new window.MarkerClustering({
                minClusterSize: 2,
                maxZoom: 13,
                map: this.map,
                markers: this.markers,
                disableClickZoom: false,
                gridSize: 120,
                icons: [htmlMarker1],
                indexGenerator: [10],
                stylingFunction: function(clusterMarker, count) {
                    $(clusterMarker.getElement()).find('div:first-child').text(count);
                }
            });
        
        },
        markerReset: function()
        {
            this.isPopupVisible = false;
            if(this.lastSelectedMarker !== null)
            {
                this.lastSelectedMarker.setIcon({
                    url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                    size: new naver.maps.Size(29, 29), // 이미지 크기
                    scaledSize: new naver.maps.Size(29, 29),
                    origin: new naver.maps.Point(0, 0), // 이미지 원점
                    anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                })
            }
            this.selectedMarker = null;
            this.lastSelectedMarker = null;
        },
        share: function(info)
        {
            this.$emit('share', info)
        }
    },
    watch: 
    {
        'pharmacies': function()
        {   
            document.getElementById('map').innerHTML = '';
            this.initMap();
        }
    }
}
</script>

<style scoped>
    .maps {
        position: relative;
        width: 100%;
        height: 100vh;
    }
      /* 바텀 팝업 스타일 */
    .bottom-popup {
        position: fixed;
        bottom: -1000px; /* 초기 상태: 화면 아래에 숨김 */
        left: 0;
        width: 100%;
        background: white;
        box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
        transition: bottom 0.3s ease-in-out;
        border-radius: 15px 15px 0 0;
        z-index: 1000;
    }
    /* layout */
    @media (min-width: 600px) {
        .bottom-popup {
            width: 600px;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
      
    /* 팝업이 보일 때 */
    .bottom-popup.show {
        bottom: 0; /* 화면에 표시 */
    }
    .logo {
        width: 94px;
    }
    .header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(180deg, #F0F1F3 -19.33%, rgba(246, 247, 248, 0.75) 27.26%, rgba(255, 255, 255, 0.00) 100%);
        position: absolute;
        z-index: 10;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0%);
    }
    .list-view-button {
        border-radius: 100px;
        border: 1px solid #184FA1;
        background: var(--Gray-00, #FFF);
        display: flex;
        height: 44px;
        padding: 0 16px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px; /* 94.444% */
        cursor: pointer;
        z-index:100;
        position: absolute;
        bottom: 222px;
        left: 25.79px;
    }
    .navigator-button {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-primary-color2, #FFF);
        cursor: pointer;
        z-index:100;
        position: absolute;
        bottom: 222px;
        right: 25.79px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .speech-bubble {
        position: relative;
        background: #1a1a1a;
        color: white;
        padding: 12px 16px;
        border-radius: 16px;
        font-size: 20px;
        display: inline-block;
        max-width: 90%;
    }

        /* 꼬리 만들기 */
    .speech-bubble::after {
        content: "";
        position: absolute;
        bottom: -10px; /* 말풍선 아래쪽에 붙임 */
        left: 20px;     /* 좌우 위치 조절 가능 */
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-top-color: #1a1a1a; /* 말풍선 배경색과 동일 */
    }
    .custom-button-1 {
        z-index:100;
        position: absolute;
        bottom: 284px;
        right: 25.79px;
        width: 56px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .map-search-button {
        border-radius: 100px;
        background: var(--Gray-100, #1E1E1E);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        padding: 0 16px;
        color: var(--Gray-primary-color2, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px; /* 94.444% */
        position: absolute;
        top: 57px;
        left: 50%;
        z-index: 10;
        transform: translate(-50%, 0);
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/organisms/map/Maps.vue